import { breakpoints } from "../../../../../utils/breakpoints";
import styled from "styled-components";

export const SuccessCasesComponent = styled.div`
  width: 100%;
  display: flex;
  flex-flow: column nowrap;
  align-items: center;
  background: #0c0c0c;
  gap: 40px 0;
  padding: 40px 0;

  @media (min-width: ${breakpoints.xxs}) {
  }

  @media (min-width: ${breakpoints.l}) {
    padding: 40px 0 40px 80px;
  }

  .detail-line {
    border-radius: 10px;
    width: 32px;
    border: 2px solid #7D72FF;
    height: 0;
    margin-bottom: 24px;

    @media (min-width: ${breakpoints.l}) {
      width: 48px;
      margin-bottom: 24px;
    }
  }

  p {
    color: #ffffff;
  }

  .text-swiper-wrapper {
    display: flex;
    width: 100%;
    height: 100%;
    gap: 40px 0;
    flex-direction: column;

    @media (min-width: ${breakpoints.xxs}) {
    }

    @media (max-width: 1199px) {
      align-items: center;
      gap: 20px 0;
    }

    @media (min-width: ${breakpoints.l}) {
      flex-direction: row-reverse;
      justify-content: space-between;
      gap: 0 80px;
    }

    .swiper-container {
    @media (max-width: 1199px) {
      max-width: 500px;
    }

      @media (min-width: ${breakpoints.xxs}) {
        flex-direction: column;
      }

      @media (min-width: 391px) and (max-width: 1199px) {
        width: 500px !important;
      }

      @media (min-width: ${breakpoints.xs}) and (max-width: 1199px) {
        max-width: 390px !important;
      }

      @media (min-width: ${breakpoints.s}) and (max-width: 1199px) {
        max-width: 390px !important;
      }

      @media (min-width: ${breakpoints.m}) and (max-width: 1199px) {
        max-width: 390px !important;
      }

      @media (min-width: ${breakpoints.l}) {
        width: 60%;
      }

      @media (min-width: ${breakpoints.xl}) {
        width: 55%;
      }

      @media (min-width: ${breakpoints.xxl}) {
        width: 50%;
      }

      @media (min-width: ${breakpoints.ul}) {
        width: 45%;
      }


      .swiper {

        .swiper-pagination{
          bottom: -5px;
        }

        .swiper-wrapper {
          cursor: pointer;
          display: flex;
          align-items: center;

          @media (min-width: ${breakpoints.l}) {
            display: flex;
            align-items: center;
          }

          .swiper-slide{
            width: 262px;
            height: 262px;
          }

          .swiper-slide-active{
            width: 448px !important;
            height: 448px !important;
            margin-right: 80px;
            
            @media (max-width: 1199px) {
              width: 262px !important;
              height: 262px !important;
              margin: 0 5%;
            }
          }
          
          .swiper-slide-next{
            width: 380px !important;
            height: 380px !important;
            opacity: .5;

            @media (max-width: 1199px) {
              width: 214px !important;
              height: 214px !important;
            }
          }

          .swiper-slide-prev{
            opacity: 0;
            @media (max-width: 1199px) {
              opacity: .5;
              width: 214px !important;
              height: 214px !important;
            }
          }
        }       
        }
      }
    }

    .text-pagination-wrapper {
      display: flex;
      width: 100%;
      height: 100%;
      flex-flow: column nowrap;
      justify-content: space-between;
      gap: 40px 0;
      padding: 0 24px 0 24px;

      @media (max-width: 1199px) {
        gap: 16px 0;
      }

      @media (min-width: ${breakpoints.xxs}) {
        flex-direction: column;
        width: 100%;
      }

      @media (min-width: ${breakpoints.xs}) {
        align-items: center;
        gap: 0;
      }

      @media (min-width: ${breakpoints.l}) {
        align-items: flex-start;
        justify-content: flex-start;
        padding-right: 0;
        padding: 0;
      }

      .transform-arrow {
        transform: rotate(180deg);
      }

      .arrow {
        cursor: pointer;
      }

      button {
        font-family: "Hind Madurai" !important;
        padding: 8px 56px;
        font-size: 14px;
        font-weight: 500;
        color: #ffffff;
        background: transparent;
        border: 1.5px #ffffff solid;
        border-radius: 100px;
        height: 48px;

        @media (min-width: ${breakpoints.xxs}) {
        }

        @media (min-width: ${breakpoints.xs}) {
          max-width: 75%;
        }

        @media (min-width: ${breakpoints.l}) {
          margin-top: 40px;
          font-size: 18px;
        }

        :hover {
          background: #ffffff;
          color: #000000;
          transition: ease-in-out 0.15s;
        }
      }
    }

    .pagination {
      display: flex;
      width: 100%;
      justify-content: space-between;
      align-items: end;
      padding: 0 80px 0 0;

      .previous-arrow {
        transform: rotate(180deg);
      }

      .client-logo {
        height: 32px;
      }

      .logo-text-wrapper {
        display: flex;
        flex-direction: column;
        align-items: end;
      }

      p {
        font-size: 12px;
        font-weight: 400;
        margin-bottom: 0;
      }

      .arrow-logo-wrapper {
        display: flex;
        gap: 24px;
        align-items: end;
      }
    }
    
`;

export const SwiperCard = styled.div`
  background-image: url(${(props) => `${props.backgroundImg}`});
  background-repeat: no-repeat;
  background-size: cover;
  box-shadow: 0px 12px 6px 0px rgba(0, 0, 0, 0.15);
  height: 100%;
  width: 100%;

  img {
    max-width: 13.46vw;

    @media (max-width: ${breakpoints.l}) {
      max-width: 248px
    }
  }

  @media (min-width: ${breakpoints.l}) {
      margin-bottom: 24px;
      height: 100%;
      width: 100%;
    }

 

  .gradient {
    height: 100%;
    width: 100%;
    background: linear-gradient(360deg, #000000 0%, rgba(0, 0, 0, 0) 62.42%);
    display: flex;
    flex-flow: column-reverse nowrap;
    padding-bottom: 48px;
    align-items: center;
    color: #ffffff;

    @media (min-width: ${breakpoints.xxs}) {
    }

    @media (min-width: ${breakpoints.l}) {
      margin-bottom: 24px;
      height: 100%;
      width: 100%;
    }
  }
`;

export const ContainerTopText = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
  gap: 16px;
  padding: 0 16px;

  @media (min-width: ${breakpoints.xxs}) {
    padding: 0 24px;
    }

  @media (min-width: ${breakpoints.l}) {
    padding: 0px;
  }

  .title {
    font-weight: 500;
    font-size: 2.22vw;
    font-family: "Hind Madurai" !important;
    margin: 0;

    @media (max-width: ${breakpoints.m}) {
      font-size: 6.15vw;
    }
  }

  .subtitle {
    font-weight: 400;
    margin: 0;
    font-family: "Hind Madurai" !important;
    text-align: center;
    font-size: 18px;

    @media (min-width: ${breakpoints.xxs}) {
      font-size: 4.615384615384615vw;
    }

    @media (min-width: ${breakpoints.xs}) {
      font-size: 3.125vw;
    }

    @media (min-width: ${breakpoints.s}) {
      font-size: 2.34375vw;
    }

    @media (min-width: ${breakpoints.m}) {
      font-size: 1.8225806451612903vw;
    }

    @media (min-width: ${breakpoints.l}) {
      font-size: 1.6667vw;
      line-height: 48px;
    }

    @media (min-width: ${breakpoints.xl}) {
      font-size: 1.3889vw;
    }

    @media (min-width: ${breakpoints.xxl}) {
      font-size: 1.25vw;
    }

    @media (min-width: ${breakpoints.ul}) {
      font-size: 1.0417vw;
    }
  }
`;


export const ContainerSwiperClientText = styled.div`
  display: flex;
  flex-direction: column;
  align-items: flex-start;

  @media (min-width: ${breakpoints.l}) {
    width: 38.83vw;
  }
`

export const ContainerBottomText = styled.div`
  display: flex;
  align-items: flex-start;
  justify-content: center;
  flex-direction: column;
  gap: 16px 0;

        @media (min-width: ${breakpoints.l}) {
          gap: 24px 0;
        }

    .client-name {
        font-size: 36px;
        font-family: "Hind Madurai" !important;
        font-weight: 300;
        margin: 0 !important;

        
        @media (min-width: ${breakpoints.xxs}) {
          font-size: 9.2308vw;
        }

        @media (min-width: ${breakpoints.xs}) {
          font-size: 6.2500vw;
        }

        @media (min-width: ${breakpoints.s}) {
          font-size: 4.6875vw;
        }

        @media (min-width: ${breakpoints.m}) {
          font-size: 3.6458vw;
        }

        @media (min-width: ${breakpoints.l}) {
          font-size: 4.6667vw;
          line-height: 77.28px;
        }

        @media (min-width: ${breakpoints.xl}) {
          font-size: 3.8889vw;
        }

        @media (min-width: ${breakpoints.xxl}) {
          font-size: 3.5vw;
        }

        @media (min-width: ${breakpoints.ul}) {
          font-size: 2.9167vw;
        }
      }

      .case {
        min-height: 160px;
        font-size: 20px;
        font-family: "Hind Madurai" !important;
        font-weight: 400;
        line-height: 32px;
        margin: 0 !important;

        @media (min-width: ${breakpoints.xxs}) {
          font-size: 5.1282vw;
        }

        @media (min-width: ${breakpoints.xs}) {
          min-height: auto;
          font-size: 3.4722vw;
        }

        @media (min-width: ${breakpoints.s}) {
          font-size: 2.6042vw;
        }

        @media (min-width: ${breakpoints.m}) {
          font-size: 2.0325vw;
        }

        @media (min-width: ${breakpoints.l}) {
          font-size: 1.8333vw;
          line-height: 30.36px;
        }

        @media (min-width: ${breakpoints.xl}) {
          font-size: 1.5278vw;
        }

        @media (min-width: ${breakpoints.xxl}) {
          font-size: 1.375vw;
        }

        @media (min-width: ${breakpoints.ul}) {
          font-size: 1.1458vw;
        }
      }
`;

// eslint-disable-next-line import/no-anonymous-default-export
export default () => null;
